import { EWalletId } from '@ankr.com/provider';
import { ConnectBtn } from 'modules/auth/components/ConnectBtn';
import { WalletIcon } from 'modules/auth/components/WalletIcon';
import { useTranslation } from 'modules/i18n';
import { useCallback, useMemo } from 'react';
import { useConnection } from '../../../../hooks/useConnection';
import { IConnectButtonProps } from '../../types';
import { translation } from './translation';
import { isInBinance, getDeepLink } from '@binance/w3w-utils';
import { useDetectMobile } from 'modules/common/hooks/useDetectMobile';

function getBinanceLink(isMobile: boolean) {
  if (isInBinance()) return undefined;
  if (!isMobile) return undefined;

  const { bnc } = getDeepLink(window.location.href);

  return bnc;
}

export function ConnectBinanceWeb3({
  isDisabled,
}: IConnectButtonProps): React.JSX.Element {
  const { keys, t } = useTranslation(translation);
  const { connect, isLoading } = useConnection();
  const isMobile = useDetectMobile();
  const link = useMemo(() => getBinanceLink(isMobile), [isMobile]);

  const handleConnect = useCallback(
    () =>
      connect({
        walletKey: EWalletId.binanceWallet,
      }),
    [],
  );

  return (
    <ConnectBtn
      onClick={handleConnect}
      isDisabled={isDisabled || isLoading}
      isLoading={isLoading}
      title={t(keys.title)}
      iconSlot={<WalletIcon wallet={EWalletId.binanceWallet} />}
      link={link}
    />
  );
}
